import { SET_RELOADS, ADD_RELOAD, UPDATE_RELOAD, REMOVE_RELOAD, CLEAR_RELOADS } from 'actions';

// { id: string, lat: number, lng: number, address: string, duration: number }
const initialState = [];

export default (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case SET_RELOADS:
      return payload;
    case ADD_RELOAD:
      return [...state, payload];
    case UPDATE_RELOAD: {
      const { id, ...props } = payload;
      return state.map((r) => (r.id === id ? { ...r, ...props } : r));
    }
    case REMOVE_RELOAD:
      return state.filter((r) => r.id !== payload);
    case CLEAR_RELOADS:
      return initialState;
    default:
      return state;
  }
};
